import React, { useContext } from 'react';
import { IOneActFlow, IActFlow } from '../../component';
import { formatImage } from '../../utils/util';
import { getPendantColor, alpha } from '../../utils/color';
import './ActFlow.scss';

import { ThemeContext } from '../../store/ThemeProvider';

const ActFlow = function(props: IActFlow) {
  const { content, edittype } = props;

  const themeContext = useContext(ThemeContext);
  const [bgColor, foreColor] = getPendantColor(themeContext.mainColor);

  const renderTitle = (it: any, index: number) => {
    return (
      <div className="actflow-title" key={index}>
        <div
          className="left"
          style={{
            background: themeContext.mainColor,
            color: foreColor
          }}
        >
          {it.title}
        </div>
        <div
          className="right"
          style={{
            borderColor: themeContext.mainColor,
            color: themeContext.mainColor
          }}
        >
          {it.date}
        </div>
      </div>
    );
  };

  const renderContent = (it: any, index: number) => {
    return (
      <div className="actflow-flow" key={index}>
        <div className="left" style={{ color: themeContext.mainColor }}>
          {it.time}
        </div>
        <div className="right" style={{ color: themeContext.h2Color }}>
          <div className="title" style={{ color: themeContext.h1Color }}>
            {it.title}
          </div>
          <div
            className="desc"
            style={{ color: alpha(themeContext.h1Color, 0.4) }}
          >
            {(it.desc || '').split(/\r|\n/).map((line: string, ind: number) => {
              return <p key={ind}>{line}</p>;
            })}
          </div>
          <div
            className="point"
            style={{
              borderColor: themeContext.mainColor,
              background: themeContext.backgroundColor
            }}
          />
        </div>
      </div>
    );
  };

  return (
    <div className="actflow">
      {(content || [])
        .map((it: any, index: number) => {
          if (it.type == 'title') {
            return renderTitle(it, index);
          }
          if (it.type == 'flow') {
            return renderContent(it, index);
          }
          return null;
        })
        .filter(Boolean)}
    </div>
  );
};

export default ActFlow;
